// extracted by css-extract-rspack-plugin
export default {"cls1":"SuggestionCard-cls1_6Ld","cls2":"SuggestionCard-cls2_z24 SuggestionCard-cls1_6Ld"};